/* global OneTrust */

const onetrustInit = () => {
	const onetrustLinks = document.querySelectorAll('[href="#onetrust"]');

	if (onetrustLinks.length > 0) {
		onetrustLinks.forEach((onetrustLink) => {
			onetrustLink.addEventListener('click', (e) => {
				if (!OneTrust) {
					return;
				}

				e.preventDefault();

				OneTrust.ToggleInfoDisplay();
			});
		});
	}
};

export default onetrustInit;
